/**
 * Serviço de Cache Global para otimizar requisições
 * Evita requisições repetidas ao backend armazenando dados em memória
 */
class CacheService {
  constructor() {
    this.cache = new Map();
    this.ttl = new Map();
    this.defaultTTL = 5 * 60 * 1000; // 5 minutos
  }

  get(key) {
    const expiry = this.ttl.get(key);
    if (expiry && Date.now() > expiry) {
      this.delete(key);
      return null;
    }
    return this.cache.get(key) || null;
  }

  set(key, value, ttl = this.defaultTTL) {
    this.cache.set(key, value);
    if (ttl > 0) {
      this.ttl.set(key, Date.now() + ttl);
    }
  }

  delete(key) {
    this.cache.delete(key);
    this.ttl.delete(key);
  }

  clear() {
    this.cache.clear();
    this.ttl.clear();
  }

  has(key) {
    return this.get(key) !== null;
  }

  async getOrFetch(key, fetchFn, ttl = this.defaultTTL) {
    const cached = this.get(key);
    if (cached !== null) {
      return Promise.resolve(cached);
    }
    try {
      const data = await fetchFn();
      this.set(key, data, ttl);
      return data;
    } catch (error) {
      console.error(`Erro ao buscar dados para cache ${key}:`, error);
      throw error;
    }
  }

  invalidateByPrefix(prefix) {
    const keys = Array.from(this.cache.keys());
    keys.forEach(key => {
      if (key.startsWith(prefix)) {
        this.delete(key);
      }
    });
  }
}

export default new CacheService();